<template>
    <!-- Info Modal -->
    <div class="modal fade" id="statModal" tabindex="-1" aria-labelledby="statModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered popOutModal">
            <div class="modal-content">
                <div v-if="!loadingDemographicData" class="modal-body d-flex flex-column py-4 align-items-center justify-content-between">
	                <div class="d-flex flex-column align-items-center">
		                <i v-if="stat.icon" class="bi inline-icon fs-4" :class="stat.icon"></i>
	                    <p class="my-2 fs-3" v-if="stat.name">{{ stat.name }}</p>
	                </div>
	                <div class="d-flex flex-column align-items-center">
		                <span class="fs-4 fw-medium" v-if="stat.value">{{ stat.value }}</span>
		                <p class="my-2 text-secondary" v-if="stat.extra">{{ stat.extra }}</p>
	                </div>
	                <div class="d-flex flex-column" v-if="Object.keys(demographicData).length > 0">
		                <div class="d-flex flex-column">
			                <div v-if="demographicData.male">
				                <span>Males: </span> <code class="text-muted">{{ demographicData.male }}</code>
			                </div>
			                <div v-if="demographicData.female">
				                <span>Females: </span> <code class="text-muted">{{ demographicData.female }}</code>
			                </div>
		                </div>
		                <div class="mt-2" v-if="demographicData.maxAgeBandPercent">
			                <small class="fw-medium">{{ demographicData.maxAgeBandPercent }}</small> <small>{{ demographicData.maxAgeBand }}</small>
		                </div>
	                </div>
                </div>
	            <div v-else class="modal-body d-flex flex-column py-4 align-items-center justify-content-between">
		            <div class="d-flex flex-column align-items-center gap-2">
			            <div class="spinner-border" role="status">
				            <span class="visually-hidden">Loading...</span>
			            </div>
			            <div class="fs-md">Loading...</div>
		            </div>
	            </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import Modal from "bootstrap/js/dist/modal";
import apiClient from "@/utils/axios.js";
import { useHttpErrorManager } from "@/composables/useHttpErrorManager.js";

const props = defineProps({
	type: String,
	id: String|Number,
	stat: {
		type: Object,
		default: () => {
			return {
				name: '',
				value: 0,
				icon: '',
				code: ''
			}
		}
	}
});

const emits = defineEmits(['closeModal']);
const modal = ref(null);

const demographicData = ref([]);
const loadingDemographicData = ref(true);
const demographicStats = async () => {
	if(props.stat.code){
		loadingDemographicData.value = true;
		try {
			const response = await apiClient.post('/helper/demographicStats', {
				'code': props.stat.code,
				'type': props.type,
				'id': props.id});
			if(response.status === 200 && response.data.length > 0){
				demographicData.value = response.data[0];

			}
		}
		catch(e){
			await useHttpErrorManager().handleError(e, true);
		}
		finally {
			loadingDemographicData.value = false;
		}
	}
	loadingDemographicData.value = false;

}

onMounted(async () => {
    var modalEl = document.getElementById('statModal');
    modal.value = Modal.getOrCreateInstance(modalEl);
    modal.value.show();

	await demographicStats();

    modalEl.addEventListener('hide.bs.modal', function (event) {
        modalEl.querySelector('.modal-dialog').classList.add('closing');
        setTimeout(() => {
            modalEl.querySelector('.modal-dialog').classList.remove('closing');
        }, 500)
        emits('closeModal');
    });
});

const close = async () => {
    if (modal.value) {
        modal.value.hide();
    }
}

defineExpose({
    close
});
</script>